module.exports = __webpack_public_path__ + "static/media/service-roof.f6bbb3ac.jpg";